import script from "./SupplierCategorySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierCategorySelect.vue?vue&type=script&setup=true&lang=js"

import "./SupplierCategorySelect.vue?vue&type=style&index=0&id=52ab67e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ab67e8"]])

export default __exports__